(function() {
  "use strict";

  var MAPBOX_TOKEN =
    "pk.eyJ1Ijoic2VtaWxvY2F0b3IyMDI1IiwiYSI6ImNtanFteTA2eTMyMzIzaG9sODFzbjM4NWgifQ.ulLE-vR8_Q_iNULAK71dbg";


  var SEARCH_TIMEOUT_MS = 12000;
  var NOMINATIM_ENDPOINT = "https://nominatim.openstreetmap.org/search";

  var CANONICAL_WATERS = [
    {
      id: "canonical-pickwick-lake",
      name: "Pickwick Lake",
      address: "Mississippi · Tennessee · Alabama",
      type: "Lake",
      provider: "Boat Ramp IQ",
      lat: 34.9559,
      lng: -88.2529
    },
    {
      id: "canonical-sardis-lake",
      name: "Sardis Lake",
      address: "Sardis, Mississippi",
      type: "Lake",
      provider: "Boat Ramp IQ",
      lat: 34.4107,
      lng: -89.7987
    },
    {
      id: "canonical-arkabutla-lake",
      name: "Arkabutla Lake",
      address: "Coldwater, Mississippi",
      type: "Lake",
      provider: "Boat Ramp IQ",
      lat: 34.7573,
      lng: -90.1127
    },
    {
      id: "canonical-grenada-lake",
      name: "Grenada Lake",
      address: "Grenada, Mississippi",
      type: "Lake",
      provider: "Boat Ramp IQ",
      lat: 33.8080,
      lng: -89.7167
    },
    {
      id: "canonical-ross-barnett",
      name: "Ross Barnett Reservoir",
      address: "Jackson metro, Mississippi",
      type: "Reservoir",
      provider: "Boat Ramp IQ",
      lat: 32.4383,
      lng: -89.9868
    },
    {
      id: "canonical-mobile-bay",
      name: "Mobile Bay",
      address: "Coastal Alabama",
      type: "Bay",
      provider: "Boat Ramp IQ",
      lat: 30.4750,
      lng: -87.9850
    },
    {
      id: "canonical-destin-harbor",
      name: "Destin Harbor",
      address: "Destin, Florida",
      type: "Harbor",
      provider: "Boat Ramp IQ",
      lat: 30.3935,
      lng: -86.4958
    },
    {
      id: "canonical-biloxi-back-bay",
      name: "Biloxi Back Bay",
      address: "Mississippi Gulf Coast",
      type: "Bay",
      provider: "Boat Ramp IQ",
      lat: 30.4172,
      lng: -88.9038
    },
    {
      id: "canonical-pensacola-bay",
      name: "Pensacola Bay",
      address: "Pensacola, Florida",
      type: "Bay",
      provider: "Boat Ramp IQ",
      lat: 30.3900,
      lng: -87.1650
    },
    {
      id: "canonical-mississippi-river-greenville",
      name: "Mississippi River — Greenville",
      address: "Greenville, Mississippi",
      type: "River",
      provider: "Boat Ramp IQ",
      lat: 33.4086,
      lng: -91.0618
    },
    {
      id: "canonical-mississippi-river-vicksburg",
      name: "Mississippi River — Vicksburg",
      address: "Vicksburg, Mississippi",
      type: "River",
      provider: "Boat Ramp IQ",
      lat: 32.3526,
      lng: -90.8779
    },
    {
      id: "canonical-mississippi-river-memphis",
      name: "Mississippi River — Memphis",
      address: "Memphis, Tennessee",
      type: "River",
      provider: "Boat Ramp IQ",
      lat: 35.1495,
      lng: -90.0490
    },
    {
      id: "canonical-mississippi-river-cape-girardeau",
      name: "Mississippi River — Cape Girardeau",
      address: "Cape Girardeau, Missouri",
      type: "River",
      provider: "Boat Ramp IQ",
      lat: 37.3059,
      lng: -89.5181
    },
    {
      id: "canonical-mississippi-river-st-louis",
      name: "Mississippi River — St. Louis",
      address: "St. Louis, Missouri",
      type: "River",
      provider: "Boat Ramp IQ",
      lat: 38.6270,
      lng: -90.1800
    }
  ];

  var form = document.getElementById("bri-ramp-search-form");
  var input = document.getElementById("bri-ramp-search-input");
  var searchButton = document.getElementById("bri-find-search-button");
  var locationButton = document.getElementById("bri-use-location");
  var status = document.getElementById("bri-find-status");
  var suggestions = document.getElementById("bri-find-suggestions");
  var handoff = document.getElementById("bri-find-handoff");
  var selectedTitle = document.getElementById("bri-find-selected-title");
  var selectedSubtitle = document.getElementById("bri-find-selected-subtitle");
  var openMapButton = document.getElementById("bri-find-open-map");
  var quickButtons = Array.prototype.slice.call(
    document.querySelectorAll(".bri-find-quick")
  );
  var purposeInputs = Array.prototype.slice.call(
    document.querySelectorAll('input[name="bri-launch-purpose"]')
  );

  if (!form || !input || !searchButton || !suggestions) {
    return;
  }

  var activeController = null;
  var debounceTimer = null;
  var committedLocation = null;
  var latestResults = [];


  function getLaunchPurpose() {
    var selectedValue = "recreation";

    purposeInputs.forEach(function(item) {
      if (item.checked) {
        selectedValue = item.value;
      }
    });

    return selectedValue;
  }

  function getPurposeLabel(value) {
    var labels = {
      "recreation": "Recreation",
      "fishing": "Fishing",
      "coastal-exploring": "Coastal Exploring",
      "diving": "Diving",
      "service-repair": "Service or Repair"
    };
    return labels[value] || "Recreation";
  }

  function inferAccessMode(result) {
    var combined = [
      result && result.name,
      result && result.address,
      result && result.type
    ].join(" ").toLowerCase();

    if (/river|levee|riverfront|river port|river landing|river access|oxbow/.test(combined)) {
      return "river";
    }

    if (/coast|ocean|gulf|bay|harbor|harbour|inlet|sound|estuary|lagoon|beach|marina|port|channel|bayou/.test(combined)) {
      return "coastal";
    }

    return "inland";
  }

  function getAccessModeLabel(value) {
    var labels = {
      "river": "River Access IQ",
      "coastal": "Coastal Access IQ",
      "inland": "Inland Access IQ"
    };

    return labels[value] || "Access IQ";
  }

  function setStatus(message, isError) {
    status.textContent = message || "";
    status.classList.toggle("is-error", Boolean(isError));
  }

  function setBusy(isBusy) {
    searchButton.disabled = isBusy;
    searchButton.textContent = isBusy ? "Finding…" : "Find Launch Area";
  }

  function closeSuggestions() {
    suggestions.classList.remove("is-open");
  }

  function escapeHTML(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalizeWords(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function canonicalMatches(rawQuery) {
    var queryWords = normalizeWords(rawQuery);

    return CANONICAL_WATERS.filter(function(item) {
      var nameWords = normalizeWords(item.name);

      return queryWords.every(function(word) {
        return nameWords.some(function(nameWord) {
          return nameWord.indexOf(word) === 0 || word.indexOf(nameWord) === 0;
        });
      });
    });
  }

  function getFeatureCoordinates(feature) {
    if (
      feature &&
      feature.geometry &&
      Array.isArray(feature.geometry.coordinates) &&
      feature.geometry.coordinates.length >= 2
    ) {
      return feature.geometry.coordinates;
    }

    return null;
  }

  function normalizeMapboxFeature(feature) {
    var coordinates = getFeatureCoordinates(feature);

    if (!coordinates) {
      return null;
    }

    var properties = feature.properties || {};
    var lng = Number(coordinates[0]);
    var lat = Number(coordinates[1]);

    if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
      return null;
    }

    var type =
      properties.feature_type ||
      properties.maki ||
      feature.place_type && feature.place_type[0] ||
      "location";

    return {
      id:
        feature.id ||
        properties.mapbox_id ||
        String(lat) + "," + String(lng),
      name:
        properties.name_preferred ||
        properties.name ||
        feature.text ||
        properties.full_address ||
        "Map location",
      address:
        properties.full_address ||
        properties.place_formatted ||
        feature.place_name ||
        properties.address ||
        "",
      type: String(type).replace(/_/g, " "),
      provider: "Mapbox",
      lat: lat,
      lng: lng
    };
  }

  function normalizeNominatimFeature(item) {
    var lat = Number(item.lat);
    var lng = Number(item.lon);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return null;
    }

    var named = item.namedetails || {};
    var address = item.address || {};
    var first = String(item.display_name || "").split(",")[0];

    return {
      id: item.place_id || String(lat) + "," + String(lng),
      name:
        named.name ||
        named["name:en"] ||
        address.water ||
        address.city ||
        address.town ||
        address.village ||
        first ||
        "Map location",
      address: item.display_name || "",
      type: String(item.type || item.class || "location").replace(/_/g, " "),
      provider: "OpenStreetMap",
      lat: lat,
      lng: lng
    };
  }

  function mapboxV6Endpoint(query) {
    return (
      "https://api.mapbox.com/search/geocode/v6/forward" +
      "?q=" + encodeURIComponent(query) +
      "&limit=8" +
      "&country=US" +
      "&language=en" +
      "&types=poi,place,locality,district,neighborhood,address" +
      "&access_token=" + encodeURIComponent(MAPBOX_TOKEN)
    );
  }

  function mapboxV5Endpoint(query) {
    return (
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
      encodeURIComponent(query) +
      ".json?limit=8&country=us&language=en&autocomplete=true" +
      "&access_token=" + encodeURIComponent(MAPBOX_TOKEN)
    );
  }

  function nominatimEndpoint(query) {
    var url = new URL(NOMINATIM_ENDPOINT);
    url.searchParams.set("q", query);
    url.searchParams.set("format", "jsonv2");
    url.searchParams.set("addressdetails", "1");
    url.searchParams.set("namedetails", "1");
    url.searchParams.set("limit", "8");
    url.searchParams.set("countrycodes", "us");
    url.searchParams.set("dedupe", "1");
    return url.toString();
  }

  function fetchWithTimeout(url, signal) {
    var controller = new AbortController();
    var timer = window.setTimeout(function() {
      controller.abort();
    }, SEARCH_TIMEOUT_MS);

    if (signal) {
      signal.addEventListener("abort", function() {
        controller.abort();
      }, { once: true });
    }

    return fetch(url, {
      signal: controller.signal,
      headers: { "Accept": "application/json" }
    }).finally(function() {
      window.clearTimeout(timer);
    });
  }

  function searchMapboxV6(query, signal) {
    return fetchWithTimeout(mapboxV6Endpoint(query), signal)
      .then(function(response) {
        if (!response.ok) {
          throw new Error("Mapbox v6 search failed.");
        }

        return response.json();
      })
      .then(function(data) {
        return (data.features || [])
          .map(normalizeMapboxFeature)
          .filter(Boolean);
      });
  }

  function searchMapboxV5(query, signal) {
    return fetchWithTimeout(mapboxV5Endpoint(query), signal)
      .then(function(response) {
        if (!response.ok) {
          throw new Error("Mapbox v5 search failed.");
        }

        return response.json();
      })
      .then(function(data) {
        return (data.features || [])
          .map(normalizeMapboxFeature)
          .filter(Boolean);
      });
  }

  function searchNominatim(query, signal) {
    return fetchWithTimeout(nominatimEndpoint(query), signal)
      .then(function(response) {
        if (!response.ok) {
          throw new Error("OpenStreetMap search failed.");
        }

        return response.json();
      })
      .then(function(data) {
        return (data || [])
          .map(normalizeNominatimFeature)
          .filter(Boolean);
      });
  }

  function buildSearchQueries(rawQuery) {
    var query = String(rawQuery || "").trim();
    var lower = query.toLowerCase();
    var queries = [query];
    var hasWaterIntent =
      /lake|reservoir|river|water|coast|ocean|gulf|bay|bayou|sound|inlet|harbor|harbour|marina|port|channel|lagoon|estuary|ramp|launch|landing|boat basin/.test(lower);

    if (query && !hasWaterIntent) {
      queries.push(query + " boat ramp");
      queries.push(query + " public boat launch");
      queries.push(query + " marina");
    }

    if (/coast|ocean|gulf|bay|bayou|sound|inlet|harbor|harbour|port|channel|lagoon|estuary|beach/.test(lower)) {
      queries.push(query + " public boat ramp");
      queries.push(query + " small boat launch");
      queries.push(query + " harbor marina");
    }

    if (/river|levee|riverfront|river landing|river access|oxbow/.test(lower)) {
      queries.push(query + " public river access");
      queries.push(query + " boat ramp");
      queries.push(query + " river landing");
    }

    return queries.filter(function(item, index, list) {
      return item && list.indexOf(item) === index;
    }).slice(0, 4);
  }

  function resultKey(result) {
    return [
      String(result.name || "").toLowerCase(),
      Number(result.lat).toFixed(4),
      Number(result.lng).toFixed(4)
    ].join("|");
  }

  function scoreResult(result, rawQuery) {
    var query = String(rawQuery || "").toLowerCase().trim();
    var queryWords = normalizeWords(query);
    var name = String(result.name || "").toLowerCase();
    var address = String(result.address || "").toLowerCase();
    var type = String(result.type || "").toLowerCase();
    var combined = name + " " + address + " " + type;
    var score = 0;

    if (result.provider === "Boat Ramp IQ") {
      score += 1000;
    }

    if (name === query) {
      score += 420;
    } else if (name.indexOf(query) === 0) {
      score += 300;
    } else if (name.indexOf(query) > -1) {
      score += 220;
    }

    queryWords.forEach(function(word) {
      if (name.split(/\s+/).some(function(token) {
        return token.indexOf(word) === 0;
      })) {
        score += 65;
      } else if (combined.indexOf(word) > -1) {
        score += 22;
      }
    });

    if (
      /lake|reservoir|river|water|waterway|basin|bay|bayou|sound|inlet|coast|ocean|gulf|marina|harbour|harbor|port|channel|lagoon|estuary|ramp|launch|landing|boat basin/.test(
        combined
      )
    ) {
      score += 180;
    }

    if (
      /street|road|avenue|lane|drive|court|boulevard|highway|address|house/.test(
        combined
      )
    ) {
      score -= 260;
    }

    if (/\b(lane|street|road|avenue|drive|court|boulevard)\b/.test(name)) {
      score -= 420;
    }

    if (query.indexOf("lake") > -1 && name.indexOf("lake") > -1) {
      score += 180;
    }

    if (
      /coast|ocean|gulf|bay|bayou|sound|inlet|harbor|harbour|port|channel|lagoon|estuary|beach/.test(query) &&
      /coast|ocean|gulf|bay|bayou|sound|inlet|harbor|harbour|port|channel|lagoon|estuary|beach|marina/.test(combined)
    ) {
      score += 210;
    }

    if (
      /river|levee|riverfront|river landing|river access|oxbow/.test(query) &&
      /river|levee|riverfront|landing|boat ramp|boat launch|public access|port/.test(combined)
    ) {
      score += 240;
    }

    if (/boat ramp|boat launch|public launch|public access|landing|marina|harbor|harbour/.test(combined)) {
      score += 110;
    }

    return score;
  }

  function mergeAndRank(groups, rawQuery) {
    var seen = {};
    var merged = [];

    canonicalMatches(rawQuery).forEach(function(item) {
      var key = resultKey(item);
      seen[key] = true;
      merged.push(item);
    });

    groups.forEach(function(group) {
      (group || []).forEach(function(result) {
        if (!result) {
          return;
        }

        var key = resultKey(result);

        if (seen[key]) {
          return;
        }

        seen[key] = true;
        merged.push(result);
      });
    });

    merged.forEach(function(result) {
      result.searchScore = scoreResult(result, rawQuery);
    });

    merged.sort(function(a, b) {
      if (b.searchScore !== a.searchScore) {
        return b.searchScore - a.searchScore;
      }

      return String(a.name).localeCompare(String(b.name));
    });

    return merged.slice(0, 10);
  }

  function fetchLocations(query) {
    if (activeController) {
      activeController.abort();
    }

    activeController = new AbortController();

    var queries = buildSearchQueries(query);
    var tasks = [];

    queries.forEach(function(searchQuery) {
      tasks.push(searchMapboxV6(searchQuery, activeController.signal));
      tasks.push(searchMapboxV5(searchQuery, activeController.signal));
      tasks.push(searchNominatim(searchQuery, activeController.signal));
    });

    var settledTasks = tasks.map(function(task) {
      return task
        .then(function(value) {
          return { status: "fulfilled", value: value };
        })
        .catch(function(error) {
          return { status: "rejected", reason: error };
        });
    });

    return Promise.all(settledTasks)
      .then(function(settled) {
        var groups = settled
          .filter(function(item) {
            return item.status === "fulfilled";
          })
          .map(function(item) {
            return item.value || [];
          });

        var ranked = mergeAndRank(groups, query);

        if (!ranked.length) {
          throw new Error("No matching location was found.");
        }

        return ranked;
      });
  }

  function renderSuggestions(results) {
    latestResults = results.slice();
    suggestions.innerHTML = "";

    if (!results.length) {
      suggestions.innerHTML =
        '<div style="padding:18px;color:#92a9b4;font-size:11px;line-height:1.6;">' +
          "No matching locations found. Try adding the state or a nearby city." +
        "</div>";
      suggestions.classList.add("is-open");
      return;
    }

    results.forEach(function(result, index) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "bri-find-suggestion";
      button.setAttribute("role", "option");
      button.setAttribute("data-index", String(index));

      button.innerHTML =
        '<span class="bri-find-suggestion-icon">' +
          '<svg viewBox="0 0 24 24">' +
            '<path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z"></path>' +
            '<circle cx="12" cy="10" r="2"></circle>' +
          "</svg>" +
        "</span>" +
        '<span class="bri-find-suggestion-copy">' +
          "<strong>" + escapeHTML(result.name) + "</strong>" +
          "<span>" +
            escapeHTML(
              (result.address || "Location result") +
              (result.provider ? " · " + result.provider : "")
            ) +
          "</span>" +
        "</span>" +
        '<span class="bri-find-suggestion-type">' +
          escapeHTML(result.type) +
        "</span>";

      button.addEventListener("click", function() {
        commitLocation(result);
      });

      suggestions.appendChild(button);
    });

    suggestions.classList.add("is-open");
  }

  function commitLocation(result) {
    committedLocation = result;
    input.value = result.name;
    closeSuggestions();

    selectedTitle.textContent = result.name;
    var purpose = getLaunchPurpose();
    var accessMode = inferAccessMode(result);

    selectedSubtitle.textContent =
      (result.address ? result.address + " · " : "") +
      getPurposeLabel(purpose) + " · " +
      getAccessModeLabel(accessMode) +
      " · Water Map will open at " +
      result.lat.toFixed(5) + ", " + result.lng.toFixed(5) + ".";

    handoff.classList.add("is-visible");
    setStatus("Location selected. Open Water Map to rank nearby inland, river, or coastal launch access.", false);
  }

  function openWaterMap() {
    if (!committedLocation) {
      setStatus("Choose a search result first.", true);
      input.focus();
      return;
    }

    var url = new URL("/pages/water-map", window.location.origin);
    url.searchParams.set("lat", String(committedLocation.lat));
    url.searchParams.set("lng", String(committedLocation.lng));
    var purpose = getLaunchPurpose();
    var accessMode = inferAccessMode(committedLocation);

    url.searchParams.set(
      "zoom",
      accessMode === "coastal" ? "11" : accessMode === "river" ? "10.8" : "12"
    );
    url.searchParams.set("query", committedLocation.name);
    url.searchParams.set("purpose", purpose);
    url.searchParams.set("access_mode", accessMode);
    url.searchParams.set("crew_mode", purpose === "service-repair" ? "1" : "0");
    url.searchParams.set("source", "find-a-ramp");

    window.location.href = url.pathname + url.search;
  }

  function runSearch(query, autoCommitFirst) {
    query = String(query || "").trim();

    if (!query) {
      setStatus("Enter a lake, river, coast, bay, inlet, harbor, marina, ramp, job site, or address.", true);
      input.focus();
      return;
    }

    setBusy(true);
    setStatus("Finding location options for “" + query + "”…", false);

    fetchLocations(query)
      .then(function(results) {
        if (!results.length) {
          renderSuggestions([]);
          setStatus("No matching location was found. Try adding the state.", true);
          return;
        }

        renderSuggestions(results);
        setStatus(
          "Choose the correct location before opening Water Map.",
          false
        );

        if (autoCommitFirst && results.length === 1) {
          commitLocation(results[0]);
        }
      })
      .catch(function(error) {
        if (error && error.name === "AbortError") {
          return;
        }

        setStatus(
          error && error.message
            ? error.message
            : "Boat Ramp IQ could not complete that search. Try adding the state.",
          true
        );
      })
      .finally(function() {
        setBusy(false);
      });
  }

  form.addEventListener("submit", function(event) {
    event.preventDefault();
    runSearch(input.value, false);
  });

  input.addEventListener("input", function() {
    clearTimeout(debounceTimer);

    var query = input.value.trim();

    committedLocation = null;
    handoff.classList.remove("is-visible");

    if (query.length < 3) {
      closeSuggestions();
      setStatus("Type at least three characters to see location options.", false);
      return;
    }

    debounceTimer = setTimeout(function() {
      runSearch(query, false);
    }, 430);
  });

  input.addEventListener("keydown", function(event) {
    if (event.key === "Escape") {
      closeSuggestions();
    }

    if (event.key === "ArrowDown" && latestResults.length) {
      var first = suggestions.querySelector(".bri-find-suggestion");
      if (first) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener("click", function(event) {
    if (!event.target.closest(".bri-find-search-box")) {
      closeSuggestions();
    }
  });

  purposeInputs.forEach(function(item) {
    item.addEventListener("change", function() {
      if (committedLocation) {
        commitLocation(committedLocation);
      } else {
        setStatus(
          getPurposeLabel(getLaunchPurpose()) +
          " ranking ready. Search a lake, river corridor, coastal area, job site, or use your location.",
          false
        );
      }
    });
  });

  openMapButton.addEventListener("click", openWaterMap);

  locationButton.addEventListener("click", function() {
    if (!navigator.geolocation) {
      setStatus("Location is not available on this device.", true);
      return;
    }

    setStatus("Finding your current location…", false);

    navigator.geolocation.getCurrentPosition(
      function(position) {
        committedLocation = {
          id: "current-location",
          name: "Your location",
          address: "Current GPS position",
          type: "location",
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        selectedTitle.textContent = "Your location";
        selectedSubtitle.textContent =
          "Water Map will open at your current GPS position.";

        handoff.classList.add("is-visible");
        setStatus("Location ready. Open Water Map to rank nearby inland, river, or coastal access.", false);
      },
      function(error) {
        setStatus(
          error && error.code === 1
            ? "Location permission was not granted."
            : "Boat Ramp IQ could not determine your location.",
          true
        );
      },
      {
        enableHighAccuracy: true,
        timeout: 12000,
        maximumAge: 30000
      }
    );
  });

  quickButtons.forEach(function(button) {
    button.addEventListener("click", function() {
      var query = button.getAttribute("data-query") || "";
      input.value = query;
      window.scrollTo({
        top: Math.max(0, form.getBoundingClientRect().top + window.scrollY - 130),
        behavior: "smooth"
      });
      runSearch(query, false);
    });
  });

  var incomingQuery = new URLSearchParams(window.location.search).get("query");

  if (incomingQuery) {
    input.value = incomingQuery;
    runSearch(incomingQuery, false);
  }
})();
